import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';
import { AutoCompleteComponent } from '@components/dynamic-form/auto-complete/auto-complete.component';
import { AutocompleteControl } from '@components/dynamic-form/auto-complete/autocomplete-control';
import { GaragePassageService } from '@services/garage-passage.service';
import { CemCustomerModel } from '@/models/cem-customer.model';
import { LoggerService } from '@services/logger.service';
import { Registry } from '@/registry.service';

@Component({
  selector: 'app-auto-complete-utilizzatore',
  templateUrl: '../../auto-complete.component.html',
  styleUrls: ['../../auto-complete.component.scss'],
})
export class AutoCompleteUtilizzatoreComponent extends AutoCompleteComponent implements OnInit {
  @Input() meta!: AutocompleteControl;
  @Input() form!: FormGroup;
  @Input() indexRow: number = null;
  @Input() keyformArrayName: any;
  control = new FormControl('');
  filteredOptions: Observable<CemCustomerModel[]>;

  constructor(private garagePassageService: GaragePassageService) {
    super();
  }

  ngOnInit(): void {
    this.setControl();

    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((value) => {
        // Se il valore è un oggetto (selezione), non fare chiamata API
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          return of([]);
        }
        // Se è una stringa, estrai il termine di ricerca
        const searchTerm = typeof value === 'string' ? value : this.getValue(value);
        if (!searchTerm || searchTerm.length < 3) {
          return of([]);
        }
        return this.garagePassageService.getCemCustomers(searchTerm);
      }),
    );
  }

  displayFn(selectedOption: any): string {
    if (!selectedOption) {
      return '';
    }
    if (typeof selectedOption === 'string') {
      return selectedOption;
    }
    const utilizzatore = selectedOption as CemCustomerModel;
    return utilizzatore.denominazione || '';
  }

  protected getValue(obj: any): string {
    if (!obj) {
      return '';
    }
    if (typeof obj === 'string') {
      return obj;
    }
    const utilizzatore = obj as CemCustomerModel;
    return utilizzatore.denominazione || '';
  }

  protected _filter(value: string): any[] {
    // Override per evitare l'errore con this.meta.options che non esiste
    // Il filtro viene gestito automaticamente da filteredOptions che usa switchMap
    // Restituisce array vuoto perché il filtro è gestito dalla chiamata API
    return [];
  }

  protected customActionChange(event) {
    // Override per evitare l'errore con this.meta.options che non esiste
    // Il filtro viene gestito automaticamente da filteredOptions che usa switchMap
    const optionValue = event.target.value;

    // Se il valore è vuoto o non è una stringa valida, non fare nulla
    // Il controllo gestirà automaticamente il valore tramite filteredOptions
    if (!optionValue || typeof optionValue !== 'string') {
      // Se il valore non è una stringa (potrebbe essere un oggetto selezionato), non fare nulla
      return;
    }
  }

  protected customActionInput(event, indexRow = null) {
    LoggerService.log('Utilizzatore Selected!');

    if (
      this.meta.classToUse &&
      this.meta.customAction &&
      Registry.getInstance().get(this.meta.classToUse) &&
      Registry.getInstance().get(this.meta.classToUse)[this.meta.customAction]
    ) {
      Registry.getInstance()
        .get(this.meta.classToUse)
        [this.meta.customAction](event.option.value, indexRow);
    } else {
      LoggerService.log('Utilizzatore selection function not found');
    }
  }
}
